// src/components/BookingHint/BookingHint.jsx
import React, { useEffect, useState } from "react";

const BookingHint = () => {
  const [visible, setVisible] = useState(false);

  // Pehmeä sisään-fade + pieni liike
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`
        max-w-6xl mx-2 mt-4 mb-2
        px-4 py-3 sm:px-6 sm:py-4
        rounded-xl
        bg-lemon/60 dark:bg-slate-900
        border-4 border-electric/55
        drop-shadow-lg
        text-center
        transition-all duration-700 ease-out
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}
      `}
    >
      <p className="font-customFont2 text-xs sm:text-sm md:text-base text-black/85 dark:text-primary tracking-wide">
        <span className="inline-block mr-1" aria-hidden="true">
          ✨
        </span>
        Varaaminen on helppoa ja stressitöntä:{" "}
        <span className="font-semibold">1)</span> Täytä lomake{" "}
        <span className="font-semibold">→ 2)</span> Lähetä{" "}
        <span className="font-semibold">→ 3)</span> Vahvista esiintyjä &amp; maksa
        varausmaksu – esiintyjä on varattu sinulle.
      </p>

      <p className="font-customFont1 text-[11px] sm:text-xs mt-1.5 text-black/75 dark:text-primary/80">
        Voit rauhassa tutustua tarjoukseen ennen päätöstä. Pelkkä tarjouspyyntö ei
        sido sinua – varaus vahvistuu vasta, kun hyväksyt tarjouksen ja maksat
        varausmaksun.
      </p>
    </div>
  );
};

export default BookingHint;
